import { PageSectionProps } from "@components/page-section/page-section";
import { AccountLanguageSelector } from "@pages/account-settings/sections/account-language-selector";
import { AccountUnitSelector } from "@pages/account-settings/sections/account-unit-selector";

/** Content for the preferences tab of account settings page */
export function accountSettingsPreferencesTab(): PageSectionProps[] {
  return [
    {
      title: "Language",
      subtitle:
        "Changes to your language will be reflected across Sphere XG applications.",
      items: [
        {
          label: "Language",
          content: <AccountLanguageSelector />,
        },
      ],
    },
    {
      title: "Units",
      subtitle: `Select your preferred units of measurement. The chosen unit
        will be used consistently across reports, charts, and project metrics.`,
      items: [
        {
          label: "Units",
          content: <AccountUnitSelector />,
          shouldHideTopBorder: true,
        },
      ],
    },
  ];
}
